/**
 * IWAO Header Interactions
 * - Drawer toggle
 * - Mega menu hover (desktop)
 * - Mobile submenu toggles
 */
(function () {
  'use strict';

  /* === DRAWER TOGGLE === */
  document.addEventListener('click', function (e) {
    var menuBtn = e.target.closest('.header__icon--menu');
    if (menuBtn) {
      var wrapper = menuBtn.closest('sticky-header.header-wrapper') || menuBtn.closest('.header-wrapper');
      if (wrapper) wrapper.classList.toggle('open_drawer');
    }
  });

  /* === MEGA MENU HOVER (Desktop) === */
  function initMegaMenuHover() {
    var megaMenus = document.querySelectorAll('details.mega-menu');

    megaMenus.forEach(function (detail) {
      var summary = detail.querySelector('summary.header__menu-item');
      var content = detail.querySelector('.mega-menu__content');
      var closeTimeout = null;
      var openTimeout = null;
      var OPEN_DELAY = 80;
      var CLOSE_DELAY = 250;
      var TRANSITION_MS = 350;

      function getWrapper() {
        return detail.closest('.header-wrapper');
      }

      function closeOtherMenus() {
        megaMenus.forEach(function (other) {
          if (other !== detail) {
            var otherContent = other.querySelector('.mega-menu__content');
            if (otherContent) otherContent.classList.remove('mega-menu--active');
            setTimeout(function () {
              other.removeAttribute('open');
            }, TRANSITION_MS);
          }
        });
      }

      function openMenu() {
        clearTimeout(closeTimeout);
        clearTimeout(openTimeout);

        openTimeout = setTimeout(function () {
          closeOtherMenus();

          detail.setAttribute('open', '');

          if (content) {
            // Force reflow then animate
            void content.offsetHeight;
            requestAnimationFrame(function () {
              content.classList.add('mega-menu--active');
            });
          }

          var wrapper = getWrapper();
          if (wrapper) wrapper.classList.add('mega-menu-is-open');
        }, OPEN_DELAY);
      }

      function closeMenu() {
        clearTimeout(openTimeout);
        closeTimeout = setTimeout(function () {
          if (content) content.classList.remove('mega-menu--active');

          setTimeout(function () {
            detail.removeAttribute('open');

            var wrapper = getWrapper();
            if (wrapper) {
              var anyOpen = wrapper.querySelector('.mega-menu__content.mega-menu--active');
              if (!anyOpen) wrapper.classList.remove('mega-menu-is-open');
            }
          }, TRANSITION_MS);
        }, CLOSE_DELAY);
      }

      if (summary) {
        summary.addEventListener('mouseenter', openMenu);
        summary.addEventListener('click', function (e) {
          //e.preventDefault();
        });
      }

      if (content) {
        content.addEventListener('mouseenter', function () {
          clearTimeout(closeTimeout);
          clearTimeout(openTimeout);
        });
      }

      [summary, content].forEach(function (el) {
        if (el) {
          el.addEventListener('mouseleave', function (e) {
            if (!e.relatedTarget || !detail.contains(e.relatedTarget)) {
              closeMenu();
            }
          });
        }
      });
    });
  }

  /* === MOBILE SUBMENU TOGGLES (legacy) === */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.menu_wrapper----col span');
    if (toggle) {
      var item = toggle.closest('.custom_wrapper_item');
      if (item) {
        item.classList.toggle('active');
        var submenu = item.querySelector('.custom_wrapper_item_ul');
        if (submenu) {
          submenu.style.display = item.classList.contains('active') ? 'block' : 'none';
        }
      }
    }
  });

  /* === MOBILE MEGA MENU ACCORDION TOGGLES === */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mega-toggle]');
    if (!btn) return;
    var section = btn.closest('[data-mega-section]');
    if (!section) return;
    section.classList.toggle('is-open');
  });

  /* === INIT === */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuHover);
  } else {
    initMegaMenuHover();
  }
})();
